
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import history from '../../utils/history';
import NotFound from '../../containers/NotFound';
import BlockingLoader from '../../components/BlockingLoader';
import DynamicImport from './DynamicImport';
import GuestUserProtectedRoutes from './GuestUserProtectedRoutes';
import PublicRoute from './PublicRoute';
import ROUTE_CONSTANTS from '../../constants/RouteConstants';
import isSelfOnboardingEnabled from '../../utils/isSelfOnboardingEnabled';
import isL1RevampEnabled from '../../utils/isL1RevampEnabled';
import getGlobalInfo from '../../actions/getGlobalInfo';
import { useTheme } from '@hmsexp/component-library';
// const DummyPublicRoute = props => (
//     <DynamicImport
//         load={() => import('../../components/PublicComponent' /* webpackChunkName: 'DynamicPublicRoute' */)}
//         componentProps={props}
//     />
// )

// const DummyProtectedRoute = props => {
//     <DynamicImport
//         load={() => import('../../components/ProtectedComponent' /* webpackChunkName: 'DynamicProtectedRoute' */)}
//         componentProps={props}
//     />
// }

const PropertyMiddleware = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import(
        '../../containers/PropertyMiddleware' /* webpackChunkName: 'PropertyMiddleware' */
      )
    }
    componentProps={props}
  />
);

const SignUp = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import('../../containers/signUp' /* webpackChunkName: 'SignUp' */)
    }
    componentProps={props}
  />
);
const OTPsignUp = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import(
        '../../containers/OTPsignUp' /* webpackChunkName: 'OTPsignUp' */
      )
    }
    componentProps={props}
  />
);

const PropertyOnboardDashboard = props => (
  <DynamicImport
    load={() =>
      import(
        '../../containers/propertyOnboardDashboard' /* webpackChunkName: 'PropertyOnboardTask' */
      )
    }
    componentProps={props}
  />
);

const PropertyInfo = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import(
        '../../containers/AddNewProperty' /* webpackChunkName: 'AddNewProperty' */
      )
    }
    componentProps={props}
  />
);

const PropertyOnboardAccount = props => (
  <DynamicImport
    load={() =>
      import(
        '../../containers/propertyOnboardAccount' /* webpackChunkName: 'PropertyOnboardTask' */
      )
    }
    componentProps={props}
  />
);

const PropertyDetailReview = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import('../../containers/PropertyReview')
    } /* webpackChunkName: 'PropertyOnboardTaskDetails' */
    componentProps={props}
  />
);

const PropertyOnboardTask = props => (
  <DynamicImport
    load={() =>
      import(
        '../../containers/PropertyOnboardTask' /* webpackChunkName: 'PropertyOnboardTask' */
      )
    }
    componentProps={props}
  />
);

const PropertyOnboardTaskDetails = props => (
  <DynamicImport
    /* eslint-disable max-len */
    load={() =>
      import('../../containers/PropertyOnboardTaskDetails')
    } /* webpackChunkName: 'PropertyOnboardTaskDetails' */
    componentProps={props}
  />
);

const RouterComp = (props) => {
  const { getGlobalInfo, globalInfo, globalInfoDataAvailable, isBlockingLoaderActive, userDetails } = props;
  const theme = useTheme();

  useEffect(() => {
    getGlobalInfo({ checkCountrySpecificPath: true });
  }, []);

  return <Router>
    <div style={{ height: '100vh', display: 'flex', backgroundColor: theme.palette.background }}>
      {isBlockingLoaderActive && <BlockingLoader />}
      <Switch>
        <PublicRoute
          component={OTPsignUp}
          exact path="/"
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
        />
        <PublicRoute
          component={OTPsignUp}
          exact path={ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
        />
        <PublicRoute
          component={OTPsignUp}
          exact path={ROUTE_CONSTANTS.OYO360_PROPERTY_ONBOARD_V2}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          isCountrySpecificPath={true}
        />
        <PublicRoute
          component={SignUp}
          exact
          path={ROUTE_CONSTANTS.SOCIAL_LOGIN}
          isAuthorized={true} //Social Login path are redirect urls, not public urls, handling of authorization in SocialLogin Component
        />
        <PublicRoute
          component={OTPsignUp}
          path={ROUTE_CONSTANTS.OTPSIGNUP_VIEW}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
        />
        <PublicRoute
          component={OTPsignUp}
          path={ROUTE_CONSTANTS.OTPSIGNUP_VIEW_V2}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyMiddleware}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_MIDDLEWARE}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardDashboard}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_DASHBOARD}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          hideFooter={isL1RevampEnabled({ globalInfo, globalInfoDataAvailable })}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardDashboard}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_DASHBOARD_V2}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          hideFooter={isL1RevampEnabled({ globalInfo, globalInfoDataAvailable })}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyInfo}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_INFO}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyInfo}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_INFO_V2}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardAccount}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_ACCOUNT}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardAccount}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_ACCOUNT_V2}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyDetailReview}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_DETAILS_REVIEWS}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyDetailReview}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_DETAILS_REVIEWS_V2}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardTask}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_TASK}
          hideFooter={isL1RevampEnabled({ globalInfo, globalInfoDataAvailable })}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardTask}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_TASK_V2}
          hideFooter={isL1RevampEnabled({ globalInfo, globalInfoDataAvailable })}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardTaskDetails}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_TASk_DETAILS}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
        />
        <GuestUserProtectedRoutes
          component={PropertyOnboardTaskDetails}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_ONBOARD_TASk_DETAILS_V2}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        {/* <ProtectedRoute exact component={DummyProtectedRoute} path={ROUTE_CONSTANTS.PROTECTED_ROUTE} /> */}
        {/* <PublicRoute exact component={DummyPublicRoute} path={ROUTE_CONSTANTS.OTPSIGNUP_VIEW} /> */}
        <GuestUserProtectedRoutes
          component={PropertyMiddleware}
          exact
          path={ROUTE_CONSTANTS.PROPERTY_MIDDLEWARE_V2}
          hideFooter={true}
          isAuthorized={isSelfOnboardingEnabled({ globalInfo, globalInfoDataAvailable })}
          userDetails={userDetails}
          isCountrySpecificPath={true}
        />
        <Route exact component={NotFound} path="/404" />
        <Route component={NotFound} path="*" />
      </Switch>
    </div>
  </Router>
}

export default connect(state => ({
  globalInfo: state.global.globalInfo,
  globalInfoDataAvailable: state.global.globalInfoDataAvailable,
  isBlockingLoaderActive: state.dashboard.isBlockingLoaderActive,
  userDetails: state.dashboard.user_details,
}), { getGlobalInfo })(RouterComp);
